import React from 'react';
import { FunctionField } from 'react-admin';

import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles({
	chip: {
		fontSize: 12, 
		margin: '2px', 
	},
	chipContainer: {
		display: 'flex', 
		flexWrap: 'wrap', 
		gap: '4px', 
	}
});


const ChipArrayField = ({ 
	withTooltip = true, 
	...props 
}) => {
	const classes = useStyles();
	return (
		<FunctionField
			{...props}
			addLabel={true}
			render={record => {
				const values = record[props.source];
				if (values == null) return null;
				return (
					<div className={classes.chipContainer}>
						{values.map((value, index) => (
							withTooltip ? 
								<Chip 
									key={index}
									fontSize="small" 
									variant="outlined" 
									className={classes.chip} 
									size="small" 
									label={value} 
								/>
							: index === values.length - 1 ? value : `${value}; `
						))}
					</div>
				);
			}}
		/>
	);
};

ChipArrayField.defaultProps = {
	addLabel: true,
};

export default ChipArrayField;
